<template>
	<div class="live-place1">
		<div class="dateList" v-if="meetingDays && meetingDays.length"
			:style="color ? { '--day-active-bg': color } : null">
			<div class="item" v-for="(item, index) in meetingDays" :key="getDayKey(item) || index">
				<a href="javascript:void(0)" @click="switchDateNew(item)"
					:class="getDayKey(item) == active ? 'active' : ''">
					{{ item.name }}
					<p>{{ item.week }}</p>
				</a>
			</div>
		</div>
		<div class="live-list">
			<div class="live-item" v-for="(item, index) in scheduleList" :key="item.id || index"
				@click="onItemClick(item)">
				<div class="image cover-item">
					<img v-if="item.banner_type == 1 && item.banner" :src="item.banner" alt="" class="bannerImg"
						onerror="common.imgError(2,event)">
					<div class="bgCover3" v-if="item.banner_type == 2 && item.banner">
						<img :src="item.banner" alt="" class="bannerImg">
						<ul>
							<li v-for="ct in item.chapters" :key="ct.id"
								:style="{ 'color': item.schedule_font_color_hex ? item.schedule_font_color_hex : '#fff' }">
								<span
									:style="{ 'background-color': item.schedule_font_color_hex ? item.schedule_font_color_hex : '#fff' }"></span>
								{{ ct.name }}
							</li>
						</ul>
					</div>
					<!-- <div class="small-icon">
						<img v-if="item.live_state == 2" src="../../../../assets/images/record_icon.png">
						<img v-if="item.live_state == 1" src="../../../../assets/images/live_icon.png">
					</div> -->
				</div>
				<p class="title">{{ item.daily_preview_title ? item.daily_preview_title : item.name }}</p>
				<p class="hall-name" v-if="item.hall_name">
					<van-icon name="location-o" />
					<span>{{ item.hall_name }}</span>
				</p>
				<p class="time">
					<van-icon name="clock-o" />
					<span>{{ formatHallTime(item) }}</span>
					<span style="flex:1"></span>
					<!-- live_state 1：直播标识 2：部分录播标识 3：全部录播标识 -->
					<img class="small-icon" v-if="item.live_state == 2"
						src="../../../../assets/images/icon_record_part.png">
					<img class="small-icon" v-if="item.live_state == 3"
						src="../../../../assets/images/icon_record_all.png">
					<img class="small-icon" v-if="item.live_state == 1" src="../../../../assets/images/live_icon.png">
					<img class="small-icon" v-if="item.live_state == 0" src="../../../../assets/images/icon_record_none.png">

				</p>
			</div>
		</div>
	</div>
</template>
<script>
import { NewMeetingSessions } from '@/config/interface.js'

export default {
	props: {
		// scheduleDate: {
		// 	type: Array,
		// 	default: () => []
		// },
		meetingDays: {
			type: Array,
			default: () => []
		},
		// meetingSchedule: {
		// 	type: [Object, Array],
		// 	default: () => ({})
		// },
		color: {
			type: String,
			default: ''
		},
		showStatusIcon: {
			type: Boolean,
			default: true
		},
		rememberDate: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			active: '',
			scheduleList: [],
			inited: false,
			sessionsLoading: false,
			meeting_id: this.$route.query.meeting_id ? this.$route.query.meeting_id : this.$route.query.MT_id
		}
	},
	computed: {
		useNewDays() {
			return this.meetingDays && this.meetingDays.length > 0
		}
	},
	mounted() {
		if (this.useNewDays) {
			this.initActiveDateNew()
		} else {
			this.initActiveDate()
		}
	},
	watch: {
		'$route'() {
			this.$router.go(0)
		},
		scheduleDate() {
			if (!this.useNewDays) this.initActiveDate()
		},
		meetingDays() {
			this.initActiveDateNew()
		},
		meetingSchedule: {
			handler() {
				if (this.useNewDays) return
				if (this.active) {
					this.scheduleList = this.meetingSchedule[this.active] || []
				} else {
					this.initActiveDate()
				}
			},
			deep: true
		}
	},
	methods: {
		getDayKey(day) {
			if (!day) return ''
			if (typeof day === 'string') return day
			return day.start_day || day.name || ''
		},
		findDayByKey(key) {
			if (!key || !this.meetingDays || !this.meetingDays.length) return null
			return this.meetingDays.find(d => this.getDayKey(d) === key) || null
		},
		// 初始化活动日期(新接口)
		initActiveDateNew() {
			if (!this.meetingDays || !this.meetingDays.length) return

			const current = this.findDayByKey(this.active)
			if (this.inited && current) {
				this.switchDateNew(current)
				return
			}

			if (this.rememberDate) {
				const saved = localStorage.getItem('switch_meeting_' + this.meeting_id)
				const remembered = this.findDayByKey(saved)
				if (remembered) {
					this.switchDateNew(remembered)
					this.inited = true
					return
				}
			}

			const today = this.getToday()
			const todayItem = this.meetingDays.find(d => d.name === today)
			this.switchDateNew(todayItem || this.meetingDays[0])
			this.inited = true
		},
		switchDateNew(day) {
			if (!day) return
			const key = this.getDayKey(day)
			if (key && key === this.active && this.scheduleList.length) return
			this.active = key
			if (this.rememberDate && key) {
				localStorage.setItem('switch_meeting_' + this.meeting_id, key)
			}
			this.$nextTick(() => {
				this.fetchSessionsByDay(day)
			})
		},
		fetchSessionsByDay(day) {
			if (!this.meeting_id) return
			this.sessionsLoading = true
			const params = {
				start_day: day.start_day,
				end_day: day.end_day,
				type_name: 'live'
			}
			fetch(NewMeetingSessions(this.meeting_id), params, 'GET').then((res) => {
				this.sessionsLoading = false
				if (res.code == 0) {
					const data = res.data
					this.scheduleList = Array.isArray(data) ? data : (data && data.list) || []
				} else {
					this.scheduleList = []
				}
			}).catch(() => {
				this.sessionsLoading = false
				this.scheduleList = []
			})
		},
		initActiveDate() {
			if (!this.scheduleDate || !this.scheduleDate.length) return
			if (!this.meetingSchedule || !Object.keys(this.meetingSchedule).length) return
			if (this.inited && this.active && this.scheduleDate.indexOf(this.active) > -1) {
				this.switchDate(this.active)
				return
			}

			if (this.rememberDate) {
				let date_string = localStorage.getItem('switch_meeting_' + this.meeting_id)
				if (date_string && Object.keys(this.meetingSchedule).includes(date_string)) {
					this.switchDate(date_string)
					this.inited = true
					return
				}
			}
			let today = this.getToday()
			if (this.scheduleDate.indexOf(today) > -1) {
				this.switchDate(today)
			} else {
				this.switchDate(this.scheduleDate[0])
			}
			this.inited = true
		},
		onItemClick(item) {
			if (this.rememberDate && this.active) {
				localStorage.setItem('switch_meeting_' + this.meeting_id, this.active)
			}
			if (this.$listeners.select) {
				this.$emit('select', item)
				return
			}
			this.$router.push({
				path: '/vascularNews/meeting/liveDetail',
				query: {
					id: item.id,
					meeting_id: this.meeting_id
				}
			})
		},
		getToday() {
			let date = new Date()
			let month = date.getMonth() + 1
			let day = date.getDate()
			return month + '月' + day + '日'
		},
		switchDate(date) {
			this.active = date
			this.scheduleList = (this.meetingSchedule && this.meetingSchedule[date]) || []
		},
		formatHallTime(item) {
			if (item.start_at && item.end_at) {
				return this.handleDate(item.start_at) + '-' + this.handleDate(item.end_at)
			}
			if (item.start_at) {
				return this.handleDate(item.start_at)
			}
			return ''
		},
		handleDate(date) {
			if (!date) return ''
			let time = date.split(' ')[1].split(':')
			return time[0] + ':' + time[1]
		}
	}
}
</script>
<style lang="scss">
.live-place1 {
	margin: 0 10px;
	padding: 0px 12px 14px;
	.dateList {
		padding-top: 15px;
		display: flex;
		flex-wrap: wrap;

		.item {
			width: 25%;
			margin-bottom: 10px;
		}

		a {
			background: #ececec;
			display: block;
			border-radius: 3px;
			font-size: 13px;
			color: $color-gray;
			margin: 0 5px;
			text-align: center;
			padding: 5px 0;
		}

		a.active {
			color: white;
			background: var(--day-active-bg, $color-main);
		}
	}

	.live-list {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
	}

	.live-item {
		width: 48%;
		border: 1px solid rgba(225, 225, 225, 1);
		margin: 5px 0;
		border-radius: 5px;
		background: white;

		.title {
			line-height: 15px;
			padding: 0 8px;
			margin: 10px 0 10px;
			font-size: 14px;
			color: #1a1a1a;
			font-weight: normal;
			text-overflow: ellipsis;
			overflow: hidden;
			white-space: nowrap;
		}

		.image {
			width: 100%;
			position: relative;

			.small-icon {
				// position: absolute;
				bottom: 0px;
				right: 3px;
				width: 60px;

				img {
					width: 60px;
					// height: 30px;
				}
			}

			.bannerImg {
				min-height: 110px;
				background-color: #fff;
				width: 100%;
				border-radius: 5px 5px 0 0;
			}

			.bgCover3 {
				border-radius: 5px 5px 0 0;
				width: 100%;
				position: relative;
				overflow: hidden;

				ul {
					position: absolute;
					top: 10px;
					bottom: 10px;
					padding: 10px;
					overflow: hidden;

					p {
						font-size: 10px;
						line-height: 15px;
					}

					li {
						font-size: 8px;
						line-height: 14px;
						display: flex;
						align-items: flex-start;
					}

					span {
						display: inline-block;
						width: 3px;
						height: 3px;
						background: #000;
						border-radius: 50%;
						margin-right: 5px;
						flex-shrink: 0;
						margin-top: 6px;
					}
				}
			}
		}

		.hall-name,
		.time {
			display: flex;
			align-items: center;
			margin: 0 auto 5px;
			padding: 0 8px;
			color: $color-gray;
			font-size: 12px;

			span {
				margin-left: 5px;
				font-size: 0.3rem;
			}

			.small-icon {
				width: 50px;
			}
		}
	}
}

@media screen and (min-width: 800px) {
	.bgCover3 {
		ul {
			padding: 6% !important;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/VascularSystem/components/Meeting/MeetingPlace.vue